import CondensedStatsSection from "@/components/landing-v2/CondensedStatsSection";
import PricingSection from "@/components/landing-v2/PricingSection";
import AppShowcaseHero from "@/components/landing-v2/AppShowcaseHero";
import Footer from "@/components/landing-v2/Footer";

const BottomSections = () => {
  return (
    <>
      <CondensedStatsSection />
      <PricingSection />
      <AppShowcaseHero />
      <Footer />
    </>
  );
};

export default BottomSections;
